/**
  * @class meleActorDopplerSog
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-dopplersog>` custom web element for showing doppler radar metadata
  */

import meleActor from 'meleActor'

const PROPERTIES = _.extend({}, {
}, meleActor._properties)

export default class meleActorDopplerSog extends meleActor {
  init() {
    super.init()
    this.classList.add('indicator')
  } // init

  message({ action, params }) {
    if(action!=='mmDopplerMeta' || params.channel!==parseInt(this.parentElement.ch)) return
    const sog_kmh = params.sog ? Math.round(params.sog.sog_speed*3.6) : undefined
    const errors = params.errors || []
    this.className = errors.includes('sog_speed') || errors.includes('gps_speed') || errors.includes('mismatch_speed') ? 'red' : 'green'
    const speed = sog_kmh>=0 ? sog_kmh : '-'
    this.innerHTML = `<span class="title">${this.translate('speed.sog')}</span><span class="subtitle">${speed} km/h</span>`
  } // message

  stateChanged(value) {
    if(value==='connecting') {
      // simulate meta to make button red when client diconnects from mDoppler
      this.message({ action: 'mmDopplerMeta', params: { channel: parseInt(this.parentElement.ch), errors: ['sog_speed'] } })
    }
  } // stateChanged
} // class meleActorDopplerSog

meleActorDopplerSog._properties = PROPERTIES
meleActorDopplerSog.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-dopplersog', meleActorDopplerSog)
